import { KeyValue } from "@/main/models/common";

export enum VehicleModeEnum {
	AI = "ai",
	Manual = "manual",
}

export enum VehicleAiStepEnum {
	Capture = "capture",
	Analyzing = "analyzing",
	Form = "form",
}

export enum VehiclePhotoGroupEnum {
	Vehicle = "vehicle",
	Damage = "damage",
}

export enum VehiclePhotoSlotEnum {
	Front = "front",
	LeftSide = "leftSide",
	RightSide = "rightSide",
	Rear = "rear",
	Plate = "plate",
	Vin = "vin",
	Damage1 = "damage1",
	Damage2 = "damage2",
}

export enum VehiclePhotoIconEnum {
	CarFront = "carFront",
	CarLeftSide = "carLeftSide",
	CarRightSide = "carRightSide",
	CarRear = "carRear",
	Scan = "scan",
	Focus = "focus",
}

export interface IVehiclePhotoSlot {
	key: VehiclePhotoSlotEnum;
	group: VehiclePhotoGroupEnum;
	icon: VehiclePhotoIconEnum;
	translateKey: string;
	isRequired: boolean;
}

export interface IVehiclePhoto {
	file: File;
	previewUrl: string;
}

export type TypeVehiclePhotos = Partial<Record<VehiclePhotoSlotEnum, IVehiclePhoto>>;

export interface IAiVehicleResult {
	confidence: number;
	name: string;
	details: string;
	plate: string;
	vin: string;
}

export interface IVehicleSelected {
	guidVehicleYear?: string | null;
	guidVehicleManufacturer?: string | null;
	guidVehicleModel?: string | null;
	guidVehicleSubModel?: string | null;
}

export interface IVehicleManualForm {
	country: KeyValue | null;
	year: KeyValue | null;
	manufacturer: KeyValue | null;
	model: KeyValue | null;
	trim: KeyValue | null;
	plate: string;
	vin: string;
}
